import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

export default function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { loginWithOAuth } = useAuthStore();

  useEffect(() => {
    const token = searchParams.get('token');
    const error = searchParams.get('error');

    if (error) {
      // Redirect to login with error message
      navigate('/login?error=oauth_failed');
      return;
    }

    if (token) {
      // Use the OAuth login method
      loginWithOAuth(token).then((result) => {
        if (result.success) {
          navigate('/dashboard');
        } else {
          console.error('OAuth login failed:', result.error);
          navigate('/login?error=oauth_failed');
        }
      });
    } else {
      navigate('/login');
    }
  }, [searchParams, navigate, loginWithOAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Completing sign in...</p>
      </div>
    </div>
  );
}
